import { LazyLoadImage } from "react-lazy-load-image-component";
import 'react-lazy-load-image-component/src/effects/blur.css';
import { useTranslation } from 'react-i18next';
import { useState } from "react";
import limpiarHtml from '../Compartido/limpiarHtml.js';

const PropiedadesDestino = ({ destino, lang, ruta, propiedadesdestino, config, moneda, websgrupo }) => {

    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    const [showMore, setshowMore] = useState(-1);
    const [modalPolitica, setModalPolitica] = useState(null);

    {/* *********** */ }

    return (
        <>

            {/* ************ */}

            {modalPolitica && (
                <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }} onClick={() => setModalPolitica(null)}>
                    <div className="modal-dialog modal-dialog-centered" onClick={e => e.stopPropagation()}>
                        <div className="modal-content">
                            <div className="pb-0 border-0 modal-header">
                                <h6 className="modal-title fw-bolder">{modalPolitica.nombre}</h6>
                                <button type="button" className="btn-close" onClick={() => setModalPolitica(null)}></button>
                            </div>
                            <div className="pt-2 modal-body">
                                <p className="mb-0 small text-muted" dangerouslySetInnerHTML={{ __html: limpiarHtml(modalPolitica.descripcion) }}></p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <div className="pt-5 resultats-hotel">
                {/*main content container */}
                <div className="main-content-container">
                    {/*apartments container*/}
                    <div className="apartments-container">

                        {/*dynamic apartment cards */}
                        <div className="dynamic-apartments">
                            {
                                propiedadesdestino.map((propiedad, index) => (
                                    <div className="apartment-card" key={"d" + index}>

                                        {/* Fila superior: foto + contingut */}
                                        <div className="apartment-card-top">
                                            <a href={"/" + preidioma + t("apartamentos") + "-" + propiedad.destino.url_dinamica[lang] + "/" + propiedad.url_dinamica}>
                                                {propiedad.foto_principal && propiedad.foto_principal.length != 0 ? (
                                                    <LazyLoadImage
                                                        className="dynamic-apartment-image"
                                                        effect='blur'
                                                        threshold={10}
                                                        src={ruta + "/propiedades/" + propiedad.id + "/fotos/web/thumb/" + propiedad.foto_principal[0].nombre}
                                                        alt={propiedad.foto_principal[0].texto_alt ? propiedad.foto_principal[0].texto_alt[lang] : ""}
                                                        title={propiedad.foto_principal[0].texto_title ? propiedad.foto_principal[0].texto_title[lang] : ""}
                                                    />
                                                ) : (
                                                    <LazyLoadImage
                                                        className="dynamic-apartment-image"
                                                        effect='blur'
                                                        threshold={10}
                                                        src="/images/web/bedloop-nofoto.png"
                                                        alt=""
                                                        title=""
                                                    />
                                                )}

                                                <span className="bottom-0 px-3 py-2 mb-3 bg-white border badge rounded-pill border-secondary text-dark fw-normal text-nowrap d-md-none position-absolute end-0 ms-2">
                                                    <span className="text-muted small me-1">{t("Desde")}</span>
                                                    {String(Math.floor(propiedad.precio / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
                                                    <small>,{String((propiedad.precio / 100).toFixed(2)).split(".")[1]}</small>
                                                    {" "}{moneda}
                                                </span>

                                            </a>

                                            <div className="apartment-card-content">
                                                <div className="apartment-text">
                                                    <h3 className="gap-2 d-flex align-items-baseline justify-content-between">
                                                        <a href={"/" + preidioma + t("apartamentos") + "-" + propiedad.destino.url_dinamica[lang] + "/" + propiedad.url_dinamica}>
                                                            {
                                                                propiedad.nombre_traducido && propiedad.nombre_traducido[lang] ?
                                                                    propiedad.nombre_traducido[lang]
                                                                    :
                                                                    propiedad.nombre
                                                            }
                                                        </a>
                                                    </h3>

                                                    <div dangerouslySetInnerHTML={{ __html: propiedad.descripcion_corta?.[lang] ?? "" }}></div>

                                                    {websgrupo.activa_multiunit === 1 && propiedad.numpropiedades >= 1 && propiedad.numpropiedades <= 5 && (
                                                        <span className={propiedad.numpropiedades == 1 ? "small text-danger fw-bolder" : propiedad.numpropiedades == 2 ? "small text-warning fw-bolder" : "small text-success fw-bolder"}>
                                                            {propiedad.numpropiedades == 1
                                                                ? <i className="fa-solid fa-circle fa-beat me-1 text-danger"></i>
                                                                : propiedad.numpropiedades == 2
                                                                    ? <i className="fa-solid fa-circle fa-beat me-1 text-warning"></i>
                                                                    : null
                                                            }
                                                            {propiedad.numpropiedades == 1 ? t("Solo queda") + " 1 " + t("disponible") : t("Solo quedan") + " " + propiedad.numpropiedades + " " + t("disponibles")}
                                                        </span>
                                                    )}

                                                    <div className="apartment-tags">
                                                        <span><i className="fa-duotone fa-users"></i> {propiedad.capacidad_maxima}</span>
                                                        <span><i className="fa-duotone fa-bed"></i> {propiedad.num_habitaciones}</span>
                                                        <span><i className="fa-duotone fa-bath"></i> {propiedad.num_banyos}</span>
                                                        <span>{propiedad.ciudad}</span>
                                                    </div>
                                                </div>

                                                <div className="apartment-view">
                                                    {propiedad.by_request == 0 ? (
                                                        <a
                                                            href={"/" + preidioma + t("apartamentos") + "-" + propiedad.destino.url_dinamica[lang] + "/" + propiedad.url_dinamica}
                                                            className="btn btn-primary"
                                                            style={{ background: config.color_corporativo_web, border: "1px solid" + config.color_corporativo_web, float: "right" }}
                                                        >
                                                            <i className="fa-duotone fa-calendar-check"></i> {t("Reservar")}
                                                        </a>
                                                    ) : propiedad.by_request == 1 ? (
                                                        <a href={"/" + preidioma + t("apartamentos") + "-" + propiedad.destino.url_dinamica[lang] + "/" + propiedad.url_dinamica} className="btn btn-primary" style={{ background: "" + config.color_corporativo_web + "", border: "1px solid" + config.color_corporativo_web, float: "right" }}>
                                                            <i className="fa-duotone fa-calendar-check"></i> {t("Petición")}
                                                        </a>
                                                    ) :
                                                        ""
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div >

        </>
    );
};

export default PropiedadesDestino;
